<template>
  <slot v-bind="{ showSsoButton, ssoButtonText, ssoButtonUrl, ssoRequired }"/>
</template>

<script>
import axios from 'axios'

const CancelToken = axios.CancelToken
let cancelTokenSource

export default {
  props: {
    defaultSsoButtonText: {
      type: String,
    },
    defaultSsoEnabled: {
      type: Boolean,
    },
    defaultSsoUrl: {
      type: String,
    },
    checkLink: {
      type: String,
    },
    emailInputName: {
      type: String
    }
  },
  data() {
    return {
      sso_url: null,
      sso_required: false,
      sso_text: null,
    }
  },
  computed: {
    showSsoButton() {
      return this.defaultSsoEnabled || this.sso_url
    },
    ssoButtonText() {
      return this.sso_text != null && this.sso_text != ''
        ? this.sso_text
        : this.defaultSsoButtonText
    },
    ssoButtonUrl() {
      return this.sso_url
        ? this.sso_url
        : this.defaultSsoUrl
    },
    ssoRequired() {
      return this.sso_required
    },
    email() {
      return this.$formValues[this.emailInputName]
    }
  },
  watch: {
    async email(val) {
      if (!val) {
        return
      }

      if (cancelTokenSource) {
        cancelTokenSource.cancel()
        cancelTokenSource = null
      }

      cancelTokenSource = CancelToken.source()

      try {
        const response = await this.$http.request({
          url: this.checkLink.replace('email', val),
          method: 'get',
          cancelToken: cancelTokenSource.token,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })

        this.sso_url = response.data.sso_url
        this.sso_required = response.data.sso_required
        this.sso_text = response.data.sso_text

      } catch (e) {
        // silence
      }
    }
  }
}
</script>